
      import ClockFill from './clock-fill.vue'
      import type { App, Plugin } from 'vue'

      export const ClockFillPlugin: Plugin = {
        install(app: App) {
          app.component('ClockFill', ClockFill)
        },
      }
      export { ClockFill }
      